import { module } from 'modujs';
import verge from 'verge';
import emitter from 'tiny-emitter/instance';

export class BulbModule extends module {
    constructor(m) {
        super(m);
        this.cb = [];
        this.inViewPort = false;

        emitter.on('bulbScroll::scrolling',this.scrollHandler,this);

    }

    scrollHandler(){
        // console.log(this.el,'<------ el')
        if(verge.inY(this.el)) {
            if(!this.inViewPort) {
                this.onEnterViewport();
            }
            this.inViewPort = true;
        } else {
            if(this.inViewPort) {
                this.onExitViewport();
            }
            this.inViewPort = false;
        }
    }

    bOn(cbName, cb){
        this.cb[cbName] = cb;
    }


    dispatch(cbName, option = null){
        if(cbName in this.cb) {
            this.cb[cbName](option)
        }
    }

    onEnterViewport() {
        //console.debug('(onEnterViewport')
        this.dispatch('onEnterViewport');
    }

    onExitViewport() {
        //console.debug('(onEnterViewport')
        this.dispatch('onExitViewport');
    }

    destroy(){
        //console.log("destroying scrollHandler",this.el.classList)
        emitter.off('bulbScroll::scrolling', this.scrollHandler);
    }
}



// WEBPACK FOOTER //
// ./scripts/core/bulbModule.js